var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchParams } from "react-router-dom";
import { StyledContent, StyledError, StyledScoreButton, StyledRating, StyledSubmitButton, StyledLogoContainer, StyledLogo } from "./styled";
import { useCallback, useEffect, useState } from "react";
import { submitEnpsResponse } from "@/api/enpsApi";
import { BeatLoader } from "react-spinners";
var getScoreColor = function (score) {
    var clamped = Math.max(0, Math.min(10, score));
    var ratio = clamped / 10;
    var r = Math.round(239 * (1 - ratio) + 16 * ratio);
    var g = Math.round(68 * (1 - ratio) + 185 * ratio);
    var b = Math.round(68 * (1 - ratio) + 129 * ratio);
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
};
export var Content = function () {
    var searchParams = useSearchParams()[0];
    var _a = useState(null), params = _a[0], setParams = _a[1];
    var _b = useState(null), selectedScore = _b[0], setSelectedScore = _b[1];
    var _c = useState(false), isSubmitted = _c[0], setIsSubmitted = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(false), isExpired = _e[0], setIsExpired = _e[1];
    useEffect(function () {
        var uid = searchParams.get("uid");
        var scoreStr = searchParams.get("score");
        var campaignId = searchParams.get("campaign_id");
        var sentDateStr = searchParams.get("sent_date");
        var headcount = searchParams.get("headcount");
        if (!uid || !scoreStr || !campaignId || !sentDateStr) {
            setError("Invalid survey link");
            return;
        }
        var score = parseInt(scoreStr, 10);
        if (isNaN(score) || score < 0 || score > 10) {
            setError("Invalid score value");
            return;
        }
        var sentDate = new Date(sentDateStr);
        var now = new Date();
        if (now > sentDate) {
            setIsExpired(true);
            return;
        }
        var parsedParams = __assign({ uid: uid, score: score, campaign_id: campaignId, sent_date: sentDateStr }, (headcount && { headcount: headcount }));
        setParams(parsedParams);
        setSelectedScore(score);
    }, [searchParams]);
    var handleScoreClick = useCallback(function (value) {
        setSelectedScore(value);
        setError(null);
    }, []);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (selectedScore === null || !params)
                        return [2 /*return*/];
                    payload = __assign({ uid: params.uid, score: selectedScore, campaign_id: params.campaign_id }, (params.headcount && { headcount: params.headcount }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, submitEnpsResponse(payload)];
                case 2:
                    _a.sent();
                    setIsSubmitted(true);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error("Submission error:", err_1);
                    setError("An error occurred while saving your response. Please try again or contact support.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [selectedScore, params]);
    if (error) {
        return _jsxs(StyledContent, { children: [_jsx(StyledLogoContainer, { children: _jsx(StyledLogo, { src: "https://a.storyblok.com/f/282502/1633x567/7e2c08174e/besix-ok.png/m/256x0/filters:quality(70)", alt: "BESIX Logo" }) }), _jsx(StyledError, { children: error })] });
    }
    if (isExpired) {
        return _jsxs(StyledContent, { children: [_jsx(StyledLogoContainer, { children: _jsx(StyledLogo, { src: "https://a.storyblok.com/f/282502/1633x567/7e2c08174e/besix-ok.png/m/256x0/filters:quality(70)", alt: "BESIX Logo" }) }), _jsx("p", { children: "This survey is now closed. See you soon for another one..." })] });
    }
    if (!params) {
        return _jsxs(StyledContent, { children: [_jsx(StyledLogoContainer, { children: _jsx(StyledLogo, { src: "https://a.storyblok.com/f/282502/1633x567/7e2c08174e/besix-ok.png/m/256x0/filters:quality(70)", alt: "BESIX Logo" }) }), _jsx(BeatLoader, {})] });
    }
    if (isSubmitted) {
        return _jsxs(StyledContent, { children: [_jsx(StyledLogoContainer, { children: _jsx(StyledLogo, { src: "https://a.storyblok.com/f/282502/1633x567/7e2c08174e/besix-ok.png/m/256x0/filters:quality(70)", alt: "BESIX Logo" }) }), _jsx("p", { children: "Thank you, your response was recorded." })] });
    }
    return _jsxs(StyledContent, { children: [_jsx(StyledLogoContainer, { children: _jsx(StyledLogo, { src: "https://a.storyblok.com/f/282502/1633x567/7e2c08174e/besix-ok.png/m/256x0/filters:quality(70)", alt: "BESIX Logo" }) }), _jsx(StyledRating, { children: __spreadArray([], Array(11), true).map(function (_, i) {
                    var color = getScoreColor(i);
                    var position = 'middle';
                    if (i === 0)
                        position = 'start';
                    if (i === 10)
                        position = 'end';
                    return (_jsx(StyledScoreButton, { "$isActive": i === selectedScore, "$position": position, style: {
                            backgroundColor: color,
                            color: 'white',
                            borderColor: color,
                        }, onClick: function () { return handleScoreClick(i); }, "aria-label": "Select score ".concat(i), children: i }, i));
                }) }), error && _jsx(StyledError, { children: error }), _jsx(StyledSubmitButton, { onClick: handleSubmit, children: "Submit score" })] });
};
